import type { SurfaceMaterialModel } from '@seddi/surface-material';
import log from 'loglevel';

import type { LogoDesc } from '../domain/scene/logoTypes';
import { SHADING_MODEL_DEFAULT } from './materialConstants';
import type { SurfaceMaterialDesc } from '../domain/materialTypes';

/**
 * Find a logo material.
 * @param logo - Logo.
 * @param model - Shading model.
 */
const findMaterial = (
  logo: LogoDesc,
  model: SurfaceMaterialModel,
): SurfaceMaterialDesc | undefined => {
  return logo.materials.find((m) => m.model === model);
};

/**
 * Define a logo material.
 * @param logo - Logo.
 * @param model - Shading model.
 */
export const adapt = (
  logo: LogoDesc,
  model: SurfaceMaterialModel = SHADING_MODEL_DEFAULT,
): SurfaceMaterialDesc | undefined => {
  const material = findMaterial(logo, model);
  if (!material) {
    log.warn(`Material not found. Logo ${logo.id} does not provide required shading model`);
    return undefined;
  }
  return {
    ...material,
    id: logo.id, // override id with the one for the logo
    repeat: { x: 1.0 / logo.size.x, y: 1.0 / logo.size.y },
    tags: ['LOGO'],
  };
};
